export enum UserActionResponse {
  USER_UPDATED_SUCCESSFULLY = 'userUpdatedSuccessfully',
  USER_UPDATE_ERROR = 'userUpdateError',
  INVITE_RESENT_SUCCESSFULLY = 'inviteResentSuccessfully',
  RESEND_INVITE_ERROR = 'resendInviteError',
  INVITE_DELETED_SUCCESSFULLY = 'inviteDeletedSuccessfully',
  DELETE_INVITE_ERROR = 'deleteInviteError',
}
